import axios from "axios";
import userMixin from "./userMixin";

export default {
  methods: {
    sendReferral: async function () {
      try {
        return await this.postRequest({
          method: "post",
          url: `${process.env.VUE_APP_API_ROOT_URL}/api/dekonstruktor/contact`,
          headers: this.getHeaders(),
        });
      } catch (e) {
        console.log(e);
        return false;
      }
    },
    getSearchCount: async function (payload) {
      try {
        return await this.postRequest({
          method: "post",
          url: `${process.env.VUE_APP_API_ROOT_URL}/api/dekonstruktor/getSearchCount`,
          headers: this.getHeaders(),
          data: JSON.stringify(payload),
        });
      } catch (e) {
        console.log(e);
        return false;
      }
    },
    updatePercentage: async function (payload) {
      try {
        return await this.postRequest({
          method: "post",
          url: `${process.env.VUE_APP_API_ROOT_URL}/api/dekonstruktor/updatePercentage`,
          headers: this.getHeaders(),
          data: JSON.stringify(payload),
        });
      } catch (e) {
        console.log(e);
        return false;
      }
    },
    getWordBankByProjectName: async function (payload) {
      try {
        return await this.postRequest({
          method: "post",
          url: `${process.env.VUE_APP_API_ROOT_URL}/api/wordbank/getWordBankByProjectName`,
          headers: this.getHeaders(),
          data: JSON.stringify(payload),
        });
      } catch (e) {
        console.log(e);
        return false;
      }
    },
    UserPayments: async function (payload) {
      try {
        return await this.postRequest({
          method: "post",
          url: `${process.env.VUE_APP_API_ROOT_URL}/api/payment/getuserpayments`,
          headers: this.getHeaders(),
          data: JSON.stringify(payload),
        });
      } catch (e) {
        console.log(e);
        return false;
      }
    },
    userSelectedSearchCategory: async function (payload) {
      try {
        return await this.postRequest({
          method: "post",
          url: `${process.env.VUE_APP_API_ROOT_URL}/api/dekonstruktor/userSelectedSearchCategory`,
          headers: this.getHeaders(),
          data: JSON.stringify(payload),
        });
      } catch (e) {
        console.log(e);
        return false;
      }
    },

    updateUserPlanSearchCount: async function (payload) {
      try {
        return await this.postRequest({
          method: "post",
          url: `${process.env.VUE_APP_API_ROOT_URL}/api/plan/updateUserPlanSearchCount`,
          headers: this.getHeaders(),
          data: JSON.stringify(payload),
        });
      } catch (e) {
        console.log(e);
        return false;
      }
    },
    deactivateuserplan: async function (payload) {
      try {
        return await this.postRequest({
          method: "post",
          url: `${process.env.VUE_APP_API_ROOT_URL}/api/plan/deactivateUserPlan`,
          headers: this.getHeaders(),
          data: JSON.stringify(payload),
        });
      } catch (e) {
        console.log(e);
        return false;
      }
    },
    ProductSessionId: async function (payload) {
      try {
        return await this.postRequest({
          method: "post",
          url: `${process.env.VUE_APP_API_ROOT_URL}/api/product/getProductSessionId`,
          headers: this.getHeaders(),
          data: JSON.stringify(payload),
        });
      } catch (e) {
        console.log(e);
        return false;
      }
    },
    socialSearchReady: async function (payload) {
      try {
        return await this.postRequest({
          method: "post",
          url: `${process.env.VUE_APP_API_ROOT_URL}/api/dekonstruktor/socialsearchPercetage`,
          headers: this.getHeaders(),
          data: JSON.stringify(payload),
        });
      } catch (e) {
        console.log(e);
        return false;
      }
    },
    domainSearchReady: async function (payload) {
      try {
        return await this.postRequest({
          method: "post",
          url: `${process.env.VUE_APP_API_ROOT_URL}/api/dekonstruktor/domainsearchPercetage`,
          headers: this.getHeaders(),
          data: JSON.stringify(payload),
        });
      } catch (e) {
        console.log(e);
        return false;
      }
    },
    webSearchReady: async function (payload) {
      try {
        return await this.postRequest({
          method: "post",
          url: `${process.env.VUE_APP_API_ROOT_URL}/api/dekonstruktor/websearchPercetage`,
          headers: this.getHeaders(),
          data: JSON.stringify(payload),
        });
      } catch (e) {
        console.log(e);
        return false;
      }
    },
    uktrademarkSearchReady: async function (payload) {
      try {
        return await this.postRequest({
          method: "post",
          url: `${process.env.VUE_APP_API_ROOT_URL}/api/dekonstruktor/uksearchPercetage`,
          headers: this.getHeaders(),
          data: JSON.stringify(payload),
        });
      } catch (e) {
        console.log(e);
        return false;
      }
    },
    europetrademarkSearchReady: async function (payload) {
      try {
        return await this.postRequest({
          method: "post",
          url: `${process.env.VUE_APP_API_ROOT_URL}/api/dekonstruktor/europesearchPercetage`,
          headers: this.getHeaders(),
          data: JSON.stringify(payload),
        });
      } catch (e) {
        console.log(e);
        return false;
      }
    },
    searchTrademarkCategories: async function (term) {
      if (term != "") {
        return await axios
          .get(
            `${process.env.VUE_APP_API_ROOT_URL}/api/dekonstruktor/trademarkcategory/search/${term}`,
            {
              headers: this.getHeaders(),
            }
          )
          .then((res) => {
            return res.data;
          });
      }

      return false;
    },
    getSearchStatus: async function (searchToken) {
      return await axios
        .get(
          `${process.env.VUE_APP_API_ROOT_URL}/api/dekonstruktor/status/${searchToken}`,
          {
            headers: this.getHeaders(),
          }
        )
        .then((res) => res.data);
    },
    getTrademarkCategory: async function (payload) {
      try {
        return await this.postRequest({
          method: "post",
          url: `${process.env.VUE_APP_API_ROOT_URL}/api/dekonstruktor/trademarkcategory`,
          headers: this.getHeaders(),
          data: JSON.stringify(payload),
        });
      } catch (e) {
        console.log(e);
        return false;
      }
    },
    products: async function (payload) {
      try {
        return await this.postRequest({
          method: "post",
          url: `${process.env.VUE_APP_API_ROOT_URL}/api/product/getproduct`,
          headers: this.getHeaders(),
          data: JSON.stringify(payload),
        });
      } catch (e) {
        console.log(e);
        return false;
      }
    },
    getSaveKonstrukt: async function (payload) {
      try {
        return await this.postRequest({
          method: "post",
          url: `${process.env.VUE_APP_API_ROOT_URL}/api/wordbank/getSaveKonstruct`,
          headers: this.getHeaders(),
          data: JSON.stringify(payload),
        });
      } catch (e) {
        console.log(e);
        return false;
      }
    },
    konsruktorSearch: async function (payload) {
      try {
        return await this.postRequest({
          method: "post",
          url: `${process.env.VUE_APP_API_ROOT_URL}/api/konstruktor`,
          headers: this.getHeaders(),
          data: JSON.stringify(payload),
        });
      } catch (e) {
        console.log(e);
        return false;
      }
    },
    dekonstruktSearch: async function (payload) {
      try {
        return await this.postRequest({
          method: "post",
          url: `${process.env.VUE_APP_API_ROOT_URL}/api/dekonstruktor`,
          headers: this.getHeaders(),
          data: JSON.stringify(payload),
        });
      } catch (e) {
        console.log(e);
        return false;
      }
    },
    dekonstruktResult: async function (searchToken) {
      try {
        const response = await this.postRequest({
          method: "GET",
          url: `${process.env.VUE_APP_API_ROOT_URL}/api/dekonstruktor/result/${searchToken}`,
          headers: this.getHeaders(),
        });

        //   console.log(response.data); // LOG DATA

        return response;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },

    ukTrademarkPaginate: async function (searchToken, params) {
      try {
        const queryParams = params
          ? Object.keys(params)
              .map(
                (k) =>
                  encodeURIComponent(k) + "=" + encodeURIComponent(params[k])
              )
              .join("&")
          : "";

        return await this.postRequest({
          method: "GET",
          url: `${process.env.VUE_APP_API_ROOT_URL}/api/uk-trademark/paginate/${searchToken}?${queryParams}`,
          headers: this.getHeaders(),
        });
      } catch (e) {
        console.warn(e.message);
        return false;
      }
    },
    euTrademarkPaginate: async function (searchToken, params, categoryIds) {
      try {
        const queryParams = new URLSearchParams(params);
        if (categoryIds && categoryIds.length > 0) {
          queryParams.append("categoryIds", categoryIds);
        }

        const response = await axios.get(
          `${
            process.env.VUE_APP_API_ROOT_URL
          }/api/eu-trademark/paginate/${searchToken}?${queryParams.toString()}`,
          {
            headers: this.getHeaders(),
          }
        );

        return response.data;
      } catch (e) {
        console.warn(e.message);
        return false;
      }
    },

    webSearchPaginate: async function (searchToken, params) {
      try {
        const queryParams = params
          ? Object.keys(params)
              .map(
                (k) =>
                  encodeURIComponent(k) + "=" + encodeURIComponent(params[k])
              )
              .join("&")
          : "";

        return await this.postRequest({
          method: "GET",
          url: `${process.env.VUE_APP_API_ROOT_URL}/api/serp-search/paginate/${searchToken}?${queryParams}`,
          headers: this.getHeaders(),
        });
      } catch (e) {
        console.warn(e.message);
        return false;
      }
    },
    socialSearchPaginate: async function (
      searchToken,
      params,
      realTwitter,
      realInstagram,
      realFacebook
    ) {
      try {
        // Include the injected values as query parameters
        const queryParams = params
          ? Object.keys(params)
              .map(
                (k) =>
                  encodeURIComponent(k) + "=" + encodeURIComponent(params[k])
              )
              .join("&")
          : "";

        // Include realTwitter, realInstagram, and realFacebook as query parameters
        const url = `${process.env.VUE_APP_API_ROOT_URL}/api/social-search/paginate/${searchToken}?${queryParams}&real_twitter=${realTwitter}&real_instagram=${realInstagram}&real_facebook=${realFacebook}`;
        const headers = this.getHeaders();

        // Send the request with the updated URL

        return await this.postRequest({
          method: "GET",
          url,
          headers,
        });
      } catch (e) {
        console.warn(e.message);
        return false;
      }
    },

    socialUserSearchPaginate: async function (searchToken, params) {
      try {
        const queryParams = params
          ? Object.keys(params)
              .map(
                (k) =>
                  encodeURIComponent(k) + "=" + encodeURIComponent(params[k])
              )
              .join("&")
          : "";

        return await this.postRequest({
          method: "GET",
          url: `${process.env.VUE_APP_API_ROOT_URL}/api/social-user-search/paginate/${searchToken}?${queryParams}`,
          headers: this.getHeaders(),
        });
      } catch (e) {
        console.warn(e.message);
        return false;
      }
    },
    randomgeneratorResult: async function (payload) {
      try {
        return await this.postRequest({
          method: "post",
          url: `${process.env.VUE_APP_API_ROOT_URL}/api/konstruktor/resultrandomgenerator`,
          headers: this.getHeaders(),
          data: JSON.stringify(payload),
        });
      } catch (e) {
        console.warn(e.message);
        return false;
      }
    },
    islikeResult: async function (payload) {
      try {
        return await this.postRequest({
          method: "post",
          url: `${process.env.VUE_APP_API_ROOT_URL}/api/konstruktor/resultislike`,
          headers: this.getHeaders(),
          data: JSON.stringify(payload),
        });
      } catch (e) {
        return false;
      }
    },
    soundlikeResult: async function (payload) {
      try {
        return await this.postRequest({
          method: "post",
          url: `${process.env.VUE_APP_API_ROOT_URL}/api/konstruktor/resultsoundlike`,
          headers: this.getHeaders(),
          data: JSON.stringify(payload),
        });
      } catch (e) {
        return false;
      }
    },
    describelikeResult: async function (payload) {
      try {
        return await this.postRequest({
          method: "post",
          url: `${process.env.VUE_APP_API_ROOT_URL}/api/konstruktor/resultdescribelike`,
          headers: this.getHeaders(),
          data: JSON.stringify(payload),
        });
      } catch (e) {
        return false;
      }
    },
    urbanizeResult: async function (payload) {
      try {
        return await this.postRequest({
          method: "post",
          url: `${process.env.VUE_APP_API_ROOT_URL}/api/konstruktor/resulturbanize`,
          headers: this.getHeaders(),
          data: JSON.stringify(payload),
        });
      } catch (e) {
        return false;
      }
    },
    foreignizeResult: async function (payload) {
      try {
        return await this.postRequest({
          method: "post",
          url: `${process.env.VUE_APP_API_ROOT_URL}/api/konstruktor/resultforeignize`,
          headers: this.getHeaders(),
          data: JSON.stringify(payload),
        });
      } catch (e) {
        return false;
      }
    },
    abbrviateResult: async function (payload) {
      try {
        return await this.postRequest({
          method: "post",
          url: `${process.env.VUE_APP_API_ROOT_URL}/api/konstruktor/resultabbreviate`,
          headers: this.getHeaders(),
          data: JSON.stringify(payload),
        });
      } catch (e) {
        return false;
      }
    },
    SaveWordsForUser: async function (payload) {
      try {
        return await this.postRequest({
          method: "post",
          url: `${process.env.VUE_APP_API_ROOT_URL}/api/wordbank/SaveWordsForUser`,
          headers: this.getHeaders(),
          data: JSON.stringify(payload),
        });
      } catch (e) {
        return false;
      }
    },
    userwordExist: function (payload) {
      try {
        return this.postRequest({
          method: "post",
          url: `${process.env.VUE_APP_API_ROOT_URL}/api/konstruktor/userwordExist`,
          headers: this.getHeaders(),
          data: JSON.stringify(payload),
        });
      } catch (e) {
        return false;
      }
    },
    registerUser: async function (payload) {
      try {
        return await this.postRequest({
          method: "post",
          // url: `${process.env.API_ROOT_URL}/api/user/registerwithoutactivation`,
          url: `${process.env.VUE_APP_API_ROOT_URL}/api/user/registerwithactivation`,
          headers: this.getHeaders(),
          data: JSON.stringify(payload),
        });
      } catch (e) {
        console.log(e);
      }
    },
    activateUser: async function (payload) {
      try {
        let email = payload.email;
        let activationCode = payload.activationCode;
        return await axios.get(
          `${process.env.VUE_APP_API_ROOT_URL}/api/user/activation/` +
            email +
            "/" +
            activationCode
        );
      } catch (e) {
        if (e.response.status === 404) {
          userMixin.methods.setUserActivationFailedMsg(
            JSON.stringify(e.response.data)
          );
          return false;
        }
      }
    },
    forgetPasswordUser: async function (payload) {
      try {
        return await this.postRequest({
          method: "post",
          url: `${process.env.VUE_APP_API_ROOT_URL}/api/user/forgetpassword`,
          //url: `${process.env.API_ROOT_URL}/api/user/forgetpassword`,
          headers: this.getHeaders(),
          data: JSON.stringify(payload),
        });
      } catch (e) {
        if (e.response.status === 404) {
          userMixin.methods.setUserforgetPasswordFailedMsg(
            JSON.stringify(e.response.data)
          );
          return false;
        }
      }
    },
    changeuserdetails: async function (payload) {
      try {
        return await this.postRequest({
          method: "post",
          //url: `${process.env.API_ROOT_URL}/api/user/resetpassword`
          url: `${process.env.VUE_APP_API_ROOT_URL}/api/user/changeuserdetails`,
          headers: this.getHeaders(),
          data: JSON.stringify(payload),
        });
      } catch (e) {
        // if (e.response.status === 422) {

        return false;
        // }
      }
    },
    resetPasswordUser: async function (payload) {
      try {
        return await this.postRequest({
          method: "post",
          //url: `${process.env.API_ROOT_URL}/api/user/resetpassword`
          url: `${process.env.VUE_APP_API_ROOT_URL}/api/user/resetpassword`,
          headers: this.getHeaders(),
          data: JSON.stringify(payload),
        });
      } catch (e) {
        if (e.response.status === 422) {
          //validation failed
          userMixin.methods.setUserResetErrorStatus(e.response.status);
          userMixin.methods.setUserResetFailedMsg(
            JSON.stringify(e.response.data)
          );
          return false;
        }
        if (e.response.status === 404) {
          //user not found
          userMixin.methods.setUserResetErrorStatus(e.response.status);
          userMixin.methods.setUserResetFailedMsg(
            JSON.stringify(e.response.data)
          );
          return false;
        }
        if (e.response.status === 410) {
          //Reset Password Link Expired
          userMixin.methods.setUserResetErrorStatus(e.response.status);
          userMixin.methods.setUserResetFailedMsg(
            JSON.stringify(e.response.data)
          );
          return false;
        }
        if (e.response.status === 412) {
          //Old password do not match
          userMixin.methods.setUserResetErrorStatus(e.response.status);
          userMixin.methods.setUserResetFailedMsg(
            JSON.stringify(e.response.data)
          );
          return false;
        }
      }
    },
    loginUser: async function (payload) {
      try {
        return await this.postRequest({
          method: "post",
          // url: `${process.env.API_ROOT_URL}/api/user/login`,
          url: `${process.env.VUE_APP_API_ROOT_URL}/api/user/login`,
          headers: this.getHeaders(),
          data: JSON.stringify(payload),
        });
      } catch (e) {
        if (e.response.status === 404) {
          console.log("An error Occured");
          userMixin.methods.setUserfailedMsg(JSON.stringify(e.response.data));
          userMixin.methods.setUserLoginStatus(false);
          userMixin.methods.setUserLoginErrorStatus(e.response.status);
          return false;
        }
        if (e.response.status === 401) {
          /*Login Failed validation failed */
          userMixin.methods.setUserfailedMsg(JSON.stringify(e.response.data));
          userMixin.methods.setUserLoginStatus(false);
          userMixin.methods.setUserLoginErrorStatus(e.response.status);
          return false;
        }
        if (e.response.status === 429) {
          /*Login Failed*/
          console.log("Too many request");
          userMixin.methods.setUserfailedMsg(JSON.stringify(e.response.data));
          userMixin.methods.setUserLoginStatus(false);
          userMixin.methods.setUserLoginErrorStatus(e.response.status);
          return false;
        }
        if (e.response.status === 403) {
          /*Login Failed*/
          console.log("User account not activated");
          userMixin.methods.setUserfailedMsg(JSON.stringify(e.response.data));
          userMixin.methods.setUserLoginStatus(false);
          userMixin.methods.setUserLoginErrorStatus(e.response.status);
          return false;
        }
      }
    },
    logoutUser: async function (payload) {
      try {
        return await this.postRequest({
          method: "post",
          url: `${process.env.VUE_APP_API_ROOT_URL}/api/user/logout`,
          // url: `${process.env.API_ROOT_URL}/api/user/login`,
          headers: this.getHeaders(),
          data: JSON.stringify(payload),
        });
      } catch (e) {
        console.log(e);
      }
    },
    contactUs: async function (payload) {
      try {
        return await this.postRequest({
          method: "post",
          url: `${process.env.VUE_APP_API_ROOT_URL}/api/contact/sendContact`,
          // url: `${process.env.API_ROOT_URL}/api/user/login`,
          headers: this.getHeaders(),
          data: JSON.stringify(payload),
        });
      } catch (e) {
        console.log(e);
      }
    },
    getHeaders: function () {
      return {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userMixin.methods.getUserToken()}`,
      };
    },

    postRequest: function (config) {
      return axios(config);
    },
  },
};
